import { render } from "./masterp2h.vue?vue&type=template&id=1f296de6"
import script from "./masterp2h.vue?vue&type=script&lang=js"
export * from "./masterp2h.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__